module.exports = __webpack_public_path__ + "img/edition.2cfe699e.png";